import React from 'react';

const ProductRichContent = props => {
  const { productContent } = props;
  return (
    <div className="product-content bg-color_white pd-10 mr-t10 mr-b10">
      <div dangerouslySetInnerHTML={{ __html: productContent }} className="content"></div>
    </div>
  );
};
export default ProductRichContent;
